/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Daily_Usage_Mode_CostInputs */



/**
* | output |
* | --- |
* | "Cost" |
*
* @param {Dashboard_Daily_Usage_Mode_CostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_daily_usage_mode_cost = /** @type {((inputs?: Dashboard_Daily_Usage_Mode_CostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Daily_Usage_Mode_CostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kosten")
	return /** @type {LocalizedString} */ ("Cost")
});